const Notfound = () => {
    return ( 
        <div>404 Notfound</div>
     );
}
 
export default Notfound;